// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UdgrgQZubp96n_Ct574b {
  margin-bottom: 4.0625rem;
}

.Cpl90FGqykrr_rQdJpD0 {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 1.5rem 1.5rem;
  gap: 1.5rem 1.5rem;
}

.aKscwKagDBDLpFFyTJNm {
  max-width: 6.875rem;
  width: 100%;
  margin: auto 0;
}

.BZ812DvG5RwNd7skrYXO {
  width: 100%;
}

.QvmHx7bw3dWIj4I1Dpbe {
  margin-top: 2.5rem;
}

.JmcGBK39LbXhXnAGSpN9 {
  margin-bottom: 1.5625rem;
}

.rPPb27grFE0SEkUdpgDh.rPPb27grFE0SEkUdpgDh {
  justify-content: flex-start;
  padding: 2.5rem;
}

.iKQ_0x7bEF0uHVR1IfAe.iKQ_0x7bEF0uHVR1IfAe {
  padding-bottom: 2.5rem;
}

@media only screen and
  (max-width: 639px) {
  .UdgrgQZubp96n_Ct574b {
    margin-bottom: 3rem;
  }

  .JmcGBK39LbXhXnAGSpN9 {
    margin-bottom: 0.9375rem;
  }

  .rPPb27grFE0SEkUdpgDh.rPPb27grFE0SEkUdpgDh {
    justify-content: center;
  }

  .Cpl90FGqykrr_rQdJpD0 {
    grid-gap: 1rem 1rem;
    gap: 1rem 1rem;
    grid-template-columns: 1fr 1fr 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ProductDetailsBrandsBlock/ProductDetailsBrandsBlock.module.css"],"names":[],"mappings":"AAAA;EACE,wBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sCAAsC;EACtC,uBAAc;EAAd,kBAAc;AAChB;;AAEA;EACE,mBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAgB;AAClB;;AAEA;EACE,wBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,eAAa;AACf;;AAEA;EACE,sBAAoB;AACtB;;AAEA;;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,wBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAc;IAAd,cAAc;IACd,kCAAkC;EACpC;AACF","sourcesContent":[".productDetailsBrandsBlock {\n  margin-bottom: 65px;\n}\n\n.brandsList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  gap: 24px 24px;\n}\n\n.brandItem {\n  max-width: 110px;\n  width: 100%;\n  margin: auto 0;\n}\n\n.brandImage {\n  width: 100%;\n}\n\n.brandLink {\n  margin-top: 40px;\n}\n\n.title {\n  margin-bottom: 25px;\n}\n\n.modalHeader.modalHeader {\n  justify-content: flex-start;\n  padding: 40px;\n}\n\n.modalContent.modalContent {\n  padding-bottom: 40px;\n}\n\n@media (--mobile) {\n  .productDetailsBrandsBlock {\n    margin-bottom: 48px;\n  }\n\n  .title {\n    margin-bottom: 15px;\n  }\n\n  .modalHeader.modalHeader {\n    justify-content: center;\n  }\n\n  .brandsList {\n    gap: 16px 16px;\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"productDetailsBrandsBlock": `UdgrgQZubp96n_Ct574b`,
	"brandsList": `Cpl90FGqykrr_rQdJpD0`,
	"brandItem": `aKscwKagDBDLpFFyTJNm`,
	"brandImage": `BZ812DvG5RwNd7skrYXO`,
	"brandLink": `QvmHx7bw3dWIj4I1Dpbe`,
	"title": `JmcGBK39LbXhXnAGSpN9`,
	"modalHeader": `rPPb27grFE0SEkUdpgDh`,
	"modalContent": `iKQ_0x7bEF0uHVR1IfAe`
};
export default ___CSS_LOADER_EXPORT___;
